import { useState } from "react";
import { Heading, Image, Flex, Spacer, Box, Text, Center, Divider, Grid, GridItem, Link, Button, UnorderedList, ListItem, useMediaQuery } from "@chakra-ui/react";
import Slider from "react-slick";
import Section from "../../Component/Layout/Section";
import PageTitle from "../../Component/Page/PageTitle";
import { useQuery } from "react-query";

import { responsiveValue } from "../../assets/style/defaultTheme";
import Tab from "../../Component/Tab";
import { getPostList, getTerms } from "../../service";
import SlideArrow from "../../Component/Button/SlideArrow";
import { lineBreakToBr } from "../../util";
import { ContactSection, HistorySection } from "./style";
import LineBreakOnMobile from "../../Component/Br/LineBreakOnMobile";
import LineBreakOnDesktop from "../../Component/Br/LineBreakOnDesktop";
import { theme } from "../../assets/style/theme";
const { flexBoxDirection } = responsiveValue;

const FINANCE_TERM_ORDER = ["연차보고서", "감사보고서", "기부금품 수입 및 지출명세서"];

const getOrderedFinanceTerms = (terms?: any[]) => {
	if (!Array.isArray(terms)) return terms;

	return [...terms].sort((a, b) => {
		const aIndex = FINANCE_TERM_ORDER.findIndex((term) => a?.name?.includes(term));
		const bIndex = FINANCE_TERM_ORDER.findIndex((term) => b?.name?.includes(term));

		if (aIndex === -1 && bIndex === -1) return 0;
		if (aIndex === -1) return 1;
		if (bIndex === -1) return -1;

		return aIndex - bIndex;
	});
};

function About() {
	const [historySelected, setHistorySelected] = useState(0);
	const [financeSelected, setFinanceSelected] = useState(0);

	const { isLoading: historyTermsIsLoading, data: historyTerms } = useQuery("getHistoryTerms", () => getTerms("history_year"));
	const { isLoading: historyListIsLoading, data: historyList } = useQuery(
		["getHistoryList", historySelected, historyTerms],
		() => getPostList("history", "history_year", historyTerms?.[historySelected]?.slug || "", -1),
		{ enabled: Boolean(historyTerms?.[historySelected]) }
	);

	const { isLoading: financeTermsIsLoading, data: financeTerms } = useQuery("getfinanceTerms", () => getTerms("finance_cat"));
	const orderedFinanceTerms = getOrderedFinanceTerms(financeTerms);
	const { isLoading: financeIsLoading, data: financeList } = useQuery(
		["getFinance", financeSelected, orderedFinanceTerms],
		() => getPostList("finance", "finance_cat", orderedFinanceTerms?.[financeSelected]?.slug || "", -1),
		{ enabled: Boolean(orderedFinanceTerms?.[financeSelected]) }
	);

	const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

	const onClickHistoryItem = (item: any, index: number) => {
		setHistorySelected(index);
	};

	const onClickFinanceItem = (item: any, index: number) => {
		setFinanceSelected(index);
	};

	const historySliderSetting = {
		infinite: false,
		// centerMode: true,
		speed: 500,
		slidesToShow: isMobile ? 1 : 2,
		slidesToScroll: 1,
		nextArrow: <SlideArrow color="gr" />,
		prevArrow: <SlideArrow color="gr" />,
		// variableWidth: true,
		// variableHeight: true,
	};

	return (
		<>
			<PageTitle
				type="big"
				bgPath="about/topbg.png"
				title="숲과나눔"
				description="몇 그루의 나무가 모여야 ‘숲’이라고 할 수 있을까요? <br />제 그늘과 내음과 씨앗과 열매를 다른 나무, <br />다른 사람, 너른 세상과 나누기 시작하면<br />‘숲’이 됩니다. ‘나눔’이 됩니다."
			/>

			<Section>
				<Heading as="h1" size="5xl" color="b.bk" pb="10" id="about02">
					인사말
				</Heading>
				<Flex direction={flexBoxDirection}>
					<Text maxW="640" fontSize={isMobile ? "16px" : "16px"}>
						(재)숲과나눔 홈페이지를 찾아주신 여러분 감사드립니다.
						<br />
						<br />
						(재)숲과나눔은 날로 황폐화되어가고 위험요소가 늘어나고 있는
						<LineBreakOnDesktop /> 가정, 일터, 지역사회의 미래가 보다 안전하고 건강하며 지속가능한 곳이
						<LineBreakOnDesktop /> 되어야 한다는 우리 사회의 여망이 모여 만들어진 비영리 법인입니다.
						<LineBreakOnDesktop /> (재)숲과나눔은 미래에 주도적 역할을 할 인재를 양성하고,
						<br />
						대안을 개발하고 확산시키기 위해 사회의 여러 구성체와 대화와 지혜를
						<LineBreakOnDesktop /> 나누며 함께 실천하는 것을 목적으로 하고 있습니다.
						<br />
						<br />
						좋은 나무가 잘 자라 이룬 숲은 그 안의 모든 생명체가 서로 나누고
						<LineBreakOnDesktop /> 공생함으로써 건강한 환경을 이룹니다. 또한 지혜와 행복은 나눌수록
						<LineBreakOnDesktop /> 커진다는 사실은 누구도 부인할 수 없는 진리입니다.
						<br />
						<br />
						(재)숲과나눔은 ‘숲’의 미덕을 따르고 ‘나눔’의 힘을 믿으며,
						<LineBreakOnDesktop /> 우리의 미래를 숲과 같이 건강하고 안전하며
						<LineBreakOnDesktop />
						지속가능하게 만들 수 있도록 실천하며 나아가겠습니다
						<LineBreakOnDesktop /> 지켜봐 주시고 격려해주시고 함께 해주시기를 부탁드립니다.
						<br />
						<br />
						감사합니다.
						<br />
						<br />
						<br />
						(재)숲과나눔 이사장
						<Image src="/images/about/sign.png" maxW="190" pt="6" />
					</Text>
					<Spacer />
					<Image src="/images/about/ceo.png" maxW={isMobile ? "300" : "488"} mt={isMobile ? "10" : "0"} />
				</Flex>
			</Section>

			<Section>
				<Heading as="h1" size="5xl" pb="8" id="about05">
					함께하는 사람들
				</Heading>
				<Heading as="h2" size="2xl" color="b.g" pb="20" lineHeight="1.5">
					재단법인 숲과나눔은 각 분야 전문성을 갖춘 인사로 구성된 이사회와 위원회가
					<br />
					투명하고 공정하게 운영하고 있습니다
				</Heading>

				<Grid templateColumns={isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)"} gap={6} rowGap={10}>
					<GridItem>
						<Image src="/images/about/p01.png" />
						<Flex pt="4">
							<Text fontSize="md" paddingRight="2">
								이사장
							</Text>
							<Heading size="xl">장재연</Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
							現 아주대학교 명예교수
							<br />
							‘12~’20 환경운동연합 공동대표
							<br />
							‘09~’15 기후변화행동연구소 이사장
							<br />
							‘08~’15 기후변화건강포럼 공동대표
							<br />
							‘01~’07 시민환경연구소 소장
						</Text>
					</GridItem>
					<GridItem>
						<Image src="/images/about/p02.png" />
						<Flex pt="4">
							<Text fontSize="md" paddingRight="2">
								이사
							</Text>
							<Heading size="xl">구도완</Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
							現 환경사회연구소 소장
							<br />
							‘13~’15 한국환경사회학회 회장
							<br />
							‘05~’07 한국카톨릭대학교 사회과학연구소 연구교수
							<br />
							‘03~’04 대통령자문 지속가능발전위 수석연구위원
							<br />
							‘98~’04 한국환경정책평가연구원 연구위원
						</Text>
					</GridItem>
					<GridItem display="none">
						<Image src="/images/about/p03.png" />
						<Flex pt="4">
							<Text fontSize="md" paddingRight="2">
								이사
							</Text>
							<Heading size="xl">김호철</Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
							現 법무법인 한결 변호사
							<br />
							現 환경피해예방협회 이사
							<br />
							現 서울중앙지법 조정위원
							<br />
							‘18~’20 민주사회를 위한 변호사모임 회장
							<br />
							‘88 제 30회 사법시험 합격
						</Text>
					</GridItem>
					<GridItem>
						<Image src="/images/about/p04.png" />
						<Flex pt="4">
							<Text fontSize="md" paddingRight="2">
								이사
							</Text>
							<Heading size="xl">박영숙</Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
							現 y's partners 사장
							<br />
							現 아름다운재단 이사
							<br />
							’11 ~ ’12 국가경쟁력강화위원회 민간위원
						</Text>
					</GridItem>
					<GridItem>
						<Image src="/images/about/p05.jpg" />
						<Flex pt="4">
							<Text fontSize="md" paddingRight="2">
								이사
							</Text>
							<Heading size="xl">윤제용</Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
							現 서울대학교 공과대학 교수
							<br />
							2025-현재 공학한림원 NAEK 포럼 위원회 위원장
2019~2021 환경연구원 원장
						</Text>
					</GridItem>
					<GridItem>
						<Image src="/images/about/p09.png" />
						<Flex pt="4">
							<Text fontSize="md" paddingRight="2">
								이사
							</Text>
							<Heading size="xl">이명숙</Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
						現 법률사무소 나우리 대표변호사
						<br />
						'91~현재 한국 성폭력상담소 이사장/이사
						<br />
						'13~'16 대한변호사협회 부협회장
						<br />
						`14~'16 (사)한국여성변호사회 회장
						</Text>
					</GridItem>
					<GridItem>
						<Image src="/images/about/p06.png" />
						<Flex pt="4">
							<Text fontSize="md" paddingRight="2">
								감사
							</Text>
							<Heading size="xl">박상철</Heading>
						</Flex>
						<Divider color="b.gr" mt="4" mb="4" />
						<Text color="b.g">
							現 박상철세무회계사무소 대표
							<br />
							’08~’15 태성회계법인 상무이사
							<br />
							’05~’08 한영회계법인 세무본부
						</Text>
					</GridItem>
				</Grid>
			</Section>

			{isMobile ? (
				<PageTitle type="small" bgPath="about/bizbg.png" title="사업소개" description="재단법인 숲과나눔은 환경·안전·보건 분야의 인재 양성을 통해 안전하고 건강한 사회를 만드는 비영리재단입니다." />
			) : (
				<PageTitle type="small" bgPath="about/bizbg.png" title="사업소개" description="재단법인 숲과나눔은 환경·안전·보건 분야의 인재 양성을 통해<br/>안전하고 건강한 사회를 만드는 비영리재단입니다." />
			)}

			<Section pt={80}>
				<Heading as="h1" size="4xl" color="b.g" pb="10" id="about03">
					사업분야
				</Heading>

				<Flex justify="space-around">
					<Box maxW="sm" textAlign="center">
						<Image boxSize={isMobile ? 100 : 246} width={isMobile ? "80px" : "auto"} objectFit="contain" src="/images/about/cate01.png" pb={10} />
						<Heading as="h2" size={isMobile ? "2xl" : "4xl"} pb="4" color="b.dgr">
							환경
						</Heading>
						<Heading as="h3" size={isMobile ? "xl" : "2xl"} color="b.dgr">
							Environment
						</Heading>
					</Box>
					<Box maxW="sm" textAlign="center">
						<Image boxSize={isMobile ? 100 : 246} width={isMobile ? "80px" : "auto"} objectFit="contain" src="/images/about/cate02.png" pb={10} />
						<Heading as="h2" size={isMobile ? "2xl" : "4xl"} pb="4" color="b.dgr">
							안전
						</Heading>
						<Heading as="h3" size={isMobile ? "xl" : "2xl"} color="b.dgr">
							Safety
						</Heading>
					</Box>
					<Box maxW="sm" textAlign="center">
						<Image boxSize={isMobile ? 100 : 246} width={isMobile ? "80px" : "auto"} objectFit="contain" src="/images/about/cate03.png" pb={10} />
						<Heading as="h2" size={isMobile ? "2xl" : "4xl"} pb="4" color="b.dgr">
							보건
						</Heading>
						<Heading as="h3" size={isMobile ? "xl" : "2xl"} color="b.dgr">
							Health
						</Heading>
					</Box>
				</Flex>

				<Text fontSize="lg" pt="14" lineHeight="2">
					사회의 급격한 변화가 있을 때마다 가장 취약하고 위협받는 것이 환경·안전·보건입니다. <br />
					환경·안전·보건은 시민들의 감수성과 긴밀히 연결되어 있고, 국가와 사회의 도덕성, 공공성과도 직결되는 문제이기도 합니다. 가정, 일터, 그리고 지역사회 환경에서 다양한 환경·안전·보건 문제와 논란이 지속적으로 발생하고 있습니다. 하지만 재발 방지와
					사회구조의 개선으로 사회 역량이 모이기보다는 분쟁과 갈등에 머무는 경우가 많습니다. 그로 인해 사회적 비용이 막대한 수준으로 커지곤 합니다.
					<br />
					환경·안전·보건은 매우 중요한 분야임에도 불구하고 우수 인력이 크게 부족하고, 그로 인해 우리 사회의 전문성과 문제 해결 역량이 매우 취약한 것이 사실입니다.이런 한계를 극복하기 위해서는 환경·안전·보건 분야의 난제를 해결할 인재를 양성하고,
					합리적인 문제 해결 대안과 담론을 개발할 수 있는 사회적 역량을 갖춰야 합니다.또한 다양한 이해집단이 서로 협력하고 소통하게 만드는 능력을 키워야 합니다.
					<br />
					숲과나눔은 가정·일터·지역사회의 환경이 숲과 같이 건강하고 안전하며 지속가능한 곳이어야 한다는 우리 사회의 여망이 모여 만들어진 비영리 재단입니다.숲과나눔은 ‘숲’의 미덕과 ‘나눔’의 힘을 믿습니다. 환경·안전·보건 분야에서 주도적 역할을 할
					인재를 양성하고, 합리적인 문제 해결과 대안, 담론을 개발하고 확산시키기 위해 사회의 여러 구성원과 협력하고 소통할 수 있도록 실천하며 나아가겠습니다.
				</Text>
			</Section>

			<Section>
				<Heading as="h1" size="4xl" color="b.g" pb="10">
					재단 사무처
				</Heading>
				{/* <Center>
          <Image src="/images/about/business.png" />
        </Center> */}
				{/* {!isMobile && <iframe title="biz" src="https://koreashe.org/intro/" frameBorder="0" style={{ height: "900px", width: "100%" }}></iframe>} */}

				<Divider color="b.dgr" mt="6" mb="6" />

				<Grid templateColumns={isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem rowSpan={2}>
						<Heading size="4xl" color="b.gr">
							인재양성사업
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between" direction={flexBoxDirection}>
							<Heading size="2xl" color="b.g" pb={isMobile ? "8" : "0"}>
								연구인재 양성
							</Heading>
							<Text w={isMobile ? "100%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/01/01">석·박사과정 장학지원</Link>
								<br />
								<br />
								<Link href="/participation/01/02">글로벌리더십 장학지원</Link>
								<br />
								<br />
								<Link href="/participation/01/03">박사후펠로우 연구지원</Link>
								<br />
								<br />
								<Link href="/participation/01/04">특정주제연구자 연구지원</Link>
								<br />
								<br />
								<Link href="/participation/04/05">소규모 연구모임 지원 풀씨연구회</Link>
							</Text>
						</Flex>
						<Divider color="b.lg" mt="6" mb="6" />
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between" direction={flexBoxDirection}>
							<Heading size="2xl" color="b.g" pb={isMobile ? "8" : "0"}>
								시민사회인재 양성
							</Heading>
							<Text w="60%" fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/02/01">장기근속 공익활동가 장학지원</Link>
								<br />
								<br />
								<Link href="/participation/02/02">풀씨아카데미</Link>
								<br />
								<br />
								<Link href="/participation/02/03">풀꽃아카데미</Link>
								<br />
								<br />
								<Link href="/participation/02/04">시민과학풀씨</Link>
							</Text>
						</Flex>
					</GridItem>
				</Grid>

				<Divider color="b.dgr" mt="6" mb="6" />

				<Grid templateColumns={isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem>
						<Heading size="4xl" color="b.gr">
							대안개발사업
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between" direction={flexBoxDirection}>
							<Heading size="2xl" color="b.g" pb={isMobile ? "8" : "0"}>
								시민아이디어 지원
							</Heading>
							<Text w={isMobile ? "100%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/03/01">시민아이디어 지원 풀씨</Link>
								<br />
								<br />
								<Link href="/participation/03/02">시민아이디어 사업화 지원 풀꽃</Link>
								<br />
								<br />
								<Link href="/participation/03/03">시민아이디어 전국확대 지원 풀숲</Link>
								<br />
								<br />
								<Link href="/participation/03/04">
									국제 시민아이디어 지원 국제풀씨
									<LineBreakOnMobile />
									(Global Seed Grant)
								</Link>
								<br />
								<br />
								<Link href="/participation/03/05">미래세대를 위한 더 나은 환경 프로젝트 초록열매</Link>
								<br />
								<br />
								<Link href="/participation/03/07">초록열매 성과확산 프로젝트</Link>
								<br />
								<br />
								<Link href="/participation/03/06">카카오뱅크 청년모임 지원사업</Link>
							</Text>
						</Flex>
					</GridItem>
				</Grid>

				<Divider color="b.dgr" mt="6" mb="6" />

				<Grid templateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem rowSpan={6}>
						<Heading size="4xl" color="b.gr" lineHeight="1.5">
							교육·협력사업
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
								교육
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/05/01">미세먼지 사회과학교육 프로그램</Link>
							</Text>
						</Flex>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
								협력
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="/participation/03/01">풀씨캠프</Link>
								<br />
								<br />
								<Link href="/participation/04/04">숲과나눔 환경학술포럼</Link>
							</Text>
						</Flex>
					</GridItem>
				</Grid>

				{/* <Divider color="b.dgr" mt="6" mb="6" /> */}

				{/* <Grid templateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem rowSpan={6}>
						<Heading size="4xl" color="b.gr" lineHeight="1.5">
							풀씨행동연구소
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
								탄소중립
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								연구와 캠페인
								<br />
								<br />
								탄소중립포럼, <Link href="/participation/04/07">자전거포럼</Link>
							</Text>
						</Flex>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
								생태계 보호
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								연구와 교육
								<br />
								<br />
								생태 모니터링
							</Text>
						</Flex>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g">
								풀씨네트워크
							</Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								자원순환
								<br />
								<br />
								해양환경
								<br />
								<br />
								도시생태
							</Text>
						</Flex>
					</GridItem>
				</Grid> */}

				{/* <Divider color="b.dgr" mt="6" mb="6" />

				<Grid templateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem rowSpan={6}>
						<Heading size="4xl" color="b.gr" lineHeight="1.5">
							일환경건강센터
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Heading size="2xl" color="b.g"></Heading>
							<Text w={isMobile ? "80%" : "60%"} fontSize="xl" color="b.lg" fontWeight="bold">
								<Link href="https://cweh-koreashe.org/default/" isExternal>
									홈페이지 바로가기
								</Link>
							</Text>
						</Flex>
					</GridItem>
				</Grid> */}
			</Section>

			<Section background="llg">
				<Heading as="h1" size="4xl" color="b.g" pb="10">
					기관소개
				</Heading>
				<Grid templateColumns={isMobile ? "1fr" : "repeat(3, 1fr)"} gap={isMobile ? 12 : 6}>
					<GridItem>
						<Image src="/images/about/ins01.jpg" w="100%" h={isMobile ? "220px" : "240px"} objectFit="cover" />
						<Heading as="h2" size="2xl" color="b.g" pt="6" pb="4">
							풀씨행동연구소
						</Heading>
						<Text color="b.g" fontSize="lg" lineHeight="1.8" minH={isMobile ? "auto" : "66px"}>
							환경사회문제 해결을 위해 조직하고
							<br />
							연구하고 행동합니다.
						</Text>
						<UnorderedList color="b.g" fontSize="md" lineHeight="2" ml="5" pt={4} stylePosition="inside" styleType="disc">
							<ListItem listStyleType="disc">그린아고라</ListItem>
							<ListItem listStyleType="disc">생물다양성 보전 (더많은자연 Nature Positive, TNFD)</ListItem>
							<ListItem listStyleType="disc">재생에너지 공간계획</ListItem>
							<ListItem listStyleType="disc">안성천 생물다양성 보전 및 인재양성</ListItem>
							<ListItem listStyleType="disc">마을하천 컬렉티브</ListItem>
							<ListItem listStyleType="disc">해양공간계획</ListItem>
							<ListItem listStyleType="disc">AI인재양성</ListItem>
						</UnorderedList>
					</GridItem>

					<GridItem>
						<Image src="/images/about/ins02.jpg" w="100%" h={isMobile ? "220px" : "240px"} objectFit="cover" />
						<Heading as="h2" size="2xl" color="b.g" pt="6" pb="4">
							에코아카이브&amp;아트센터
						</Heading>
						<Text color="b.g" fontSize="lg" lineHeight="1.8" minH={isMobile ? "auto" : "66px"}>
							환경문제를 예술과 결합해 효과적으로
							<br />
							구현하고 전달합니다.
						</Text>
						<UnorderedList color="b.g" fontSize="md" lineHeight="2" ml="5" pt={4} stylePosition="inside" styleType="disc">
							<ListItem listStyleType="disc">환경아카이브 풀숲</ListItem>
							<ListItem listStyleType="disc">에코포토아카이브</ListItem>
							<ListItem listStyleType="disc">숲과나눔 공간풀숲의 전시 개최</ListItem>
							<ListItem listStyleType="disc">도서출판 풀씨</ListItem>
						</UnorderedList>
					</GridItem>

					<GridItem>
						<Image src="/images/about/ins03.jpg" w="100%" h={isMobile ? "220px" : "240px"} objectFit="cover" />
						<Heading as="h2" size="2xl" color="b.g" pt="6" pb="4">
							1인가구솔루션센터
						</Heading>
						<Text color="b.g" fontSize="lg" lineHeight="1.8" minH={isMobile ? "auto" : "66px"}>
							위기·고립 1인 가구를 선제적으로 발굴하고, 맞춤형 지원을 통해 지역사회 통합과 지속가능한 제도적 기반을 마련합니다.
						</Text>
						<UnorderedList color="b.g" fontSize="md" lineHeight="2" ml="5" pt={4} stylePosition="inside" styleType="disc">
							<ListItem listStyleType="disc">연구 (1인가구 안전, 건강 등)</ListItem>
							<ListItem listStyleType="disc">사업 (사회복지공동모금회 1인가구 컬렉티브, 김앤장 법률사무소 사례집 제작 등)</ListItem>
							<ListItem listStyleType="disc">인식개선 (캠페인 영상 제작 등)</ListItem>
							<ListItem listStyleType="disc">공론화 (1인가구토론회 개최 등)</ListItem>
						</UnorderedList>
					</GridItem>
				</Grid>
			</Section>

			<Section>
				<Heading as="h2" size="4xl" color="b.g" pt="24">
					숲과나눔
				</Heading>
				<Heading as="h2" size="3xl" color="b.g" pt="6">
					사무처
				</Heading>
				<Divider color="b.dgr" mt="6" mb="6" />

				<ContactSection>
					<Flex pb="9" direction={flexBoxDirection}>
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							사무처장
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>이지현</strong> <LineBreakOnMobile fallback="/" /> <em>사무처 총괄</em>
							</Text>
							<Text color="b.g">
								02-6318-9001 <LineBreakOnMobile fallback="/" /> <a href="mailto:ecojh@koreashe.org">ecojh@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
					{/* <Flex direction={flexBoxDirection} pb="9">
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							협동처장
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>강희영</strong> <LineBreakOnMobile fallback="/" /> <em>협동처장, 아카이브, 대외협력, 출판</em>
							</Text>
							<Text color="b.g">
								02-6318-9009 <LineBreakOnMobile fallback="/" /> <a href="mailto:hykang@koreashe.org">hykang@koreashe.org</a>
							</Text>
						</Flex>
					</Flex> */}
					<Flex direction={flexBoxDirection} pb="9">
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							재무지원
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>박준희 팀장</strong> <LineBreakOnMobile fallback="/" /> <em>회계, 세무</em>
								<br />
								<LineBreakOnMobile />
								<strong>이영주</strong> <LineBreakOnMobile fallback="/" /> <em>회계, 세무, 총무, 대관</em>
							</Text>
							<Text color="b.g">
								02-6318-9005 <LineBreakOnMobile fallback="/" /> <a href="mailto:juny719@koreashe.org">juny719@koreashe.org</a>
								<br />
								<LineBreakOnMobile />
								02-6318-9010 <LineBreakOnMobile fallback="/" /> <a href="mailto:yjlee@koreashe.org">yjlee@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
					<Flex direction={flexBoxDirection} pb="9">
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							홍보
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>이주희</strong> <LineBreakOnMobile fallback="/" />{" "}
								<em>
									홈페이지 관리, SNS,
									<LineBreakOnMobile /> 뉴스레터, 언론보도 등
								</em>
							</Text>
							<Text color="b.g">
								02-6318-9007 <LineBreakOnMobile fallback="/" /> <a href="mailto:jh@koreashe.org">jh@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
					<Flex direction={flexBoxDirection} pb="9">
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							인재양성사업
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>최영주</strong> <LineBreakOnMobile fallback="/" />{" "}
								<em>
									석·박사 장학지원, <LineBreakOnMobile />
									연구자 지원, 풀씨 연구회
								</em>
							</Text>
							<Text color="b.g">
								02-6318-9006 <LineBreakOnMobile fallback="/" /> <a href="mailto:cyjoo@koreashe.org">cyjoo@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
					<Flex direction={flexBoxDirection} pb="9">
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							대안개발사업
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>정상용</strong> <LineBreakOnMobile fallback="/" /> <em>풀꽃, 풀숲, 초록열매</em>
								<br />
								<br />
								<strong>김혜승</strong> <LineBreakOnMobile fallback="/" /> <em>풀씨, 국제풀씨</em>
							</Text>
							<Text color="b.g">
								02-6318-9003 <LineBreakOnMobile fallback="/" /> <a href="mailto:jsy00@koreashe.org">jsy00@koreashe.org</a>
								<br />
								<br />
								02-6318-9002 <LineBreakOnMobile fallback="/" /> <a href="mailto:hskim@koreashe.org">hskim@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
					<Flex direction={flexBoxDirection} pb="9">
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							교육·협력사업
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>전유영</strong>
								<br />
								<em>
									환경학술포럼, 풀씨아카데미<br/>풀꽃아카데미, 풀씨펠로우십
									<LineBreakOnMobile /> 프로그램{" "}
								</em>
							</Text>
							<Text color="b.g">
								02-6318-9004
								<LineBreakOnMobile fallback="/" />
								<a href="mailto:ontheroad@koreashe.org">ontheroad@koreashe.org</a>
							</Text>
						</Flex>						
					</Flex>
					<Flex direction={flexBoxDirection} pb="9" hidden>
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							펠로우십
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>제수민</strong> <LineBreakOnMobile fallback="/" /> <em>아카이브</em>
							</Text>
							<Text color="b.g">
								02-6959-9613 <LineBreakOnMobile fallback="/" /> <a href="mailto:sumin@koreashe.org">sumin@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
				</ContactSection>

				<Heading as="h2" size="3xl" color="b.g" pt="6">
					풀씨행동연구소
				</Heading>
				<Divider color="b.dgr" mt="6" mb="6" />
				<ContactSection>
					<Flex pb="9" direction={flexBoxDirection}>
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							연구소장
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>신재은</strong><LineBreakOnMobile fallback="/" /><em>연구소 총괄</em>
							</Text>
							<Text color="b.g">
								02-6925-4890 <LineBreakOnMobile fallback="/" /> <a href="mailto:shinje@koreashe.org">shinje@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
					<Flex pb="9" direction={flexBoxDirection}>
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							캠페이너
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>정예름</strong> <LineBreakOnMobile fallback="/" /> <em>탄소중립</em>
								<br />
								<br />
								<strong>허그림</strong> <LineBreakOnMobile fallback="/" /> <em>자원순환</em>
								<br />
								<br />
								<strong>박한</strong> <LineBreakOnMobile fallback="/" /> <em>생물다양성, 재생에너지 공존모델</em>
								<br />
								<br />
								<strong>박혜영</strong> <LineBreakOnMobile fallback="/" /> <em>에코비즈</em>
								<br />
								<br />
								<strong>정윤호</strong> <LineBreakOnMobile fallback="/" /> <em> 해양공간계획, 공존모델</em>
								<br />
								<br />
								<strong>최지원</strong> <LineBreakOnMobile fallback="/" /> <em>마을하천컬렉티브, 생물다양성</em>
								<br />
								<br />
								<strong>이윤주</strong> <LineBreakOnMobile fallback="/" /> <em>휴직</em>
							</Text>
							<Text color="b.g">	
								02-6925-4250 <LineBreakOnMobile fallback="/" /> <a href="mailto:yaerumjung@koreashe.org">yaerumjung@koreashe.org </a>
								<br />
								<br />
								02-6959-9608 <LineBreakOnMobile fallback="/" /> <a href="mailto:heo@koreashe.org">heo@koreashe.org</a>
								<br />
								<br />
								02-6925-4254 <LineBreakOnMobile fallback="/" /> <a href="mailto:cloudhan@koreashe.org">cloudhan@koreashe.org</a>
								<br />
								<br />
								02-6925-4230 <LineBreakOnMobile fallback="/" /> <a href="mailto:pheyyoung@koreashe.org">pheyyoung@koreashe.org</a>
								<br />
								<br />
								02-6925-4354 <LineBreakOnMobile fallback="/" /> <a href="mailto:oki@koreashe.org">oki@koreashe.org</a>
								<br />
								<br />
								02-6925-4353 <LineBreakOnMobile fallback="/" /> <a href="mailto:marimo@koreashe.org">marimo@koreashe.org</a>
								<br />
								<br />
								02-6925-4231 <LineBreakOnMobile fallback="/" /> <a href="mailto:fallenisland@koreashe.org">fallenisland@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
					<Flex pb="9" direction={flexBoxDirection}>
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							홍보
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>안다영</strong> <LineBreakOnMobile fallback="/" /> <em>캠페인, 모금, 쉬즈뷰 뉴스레터</em>
							</Text>
							<Text color="b.g">
							02-6959-9609 <LineBreakOnMobile fallback="/" /> <a href="mailto:ahndy@koreashe.org">ahndy@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
					<Flex pb="9" direction={flexBoxDirection} hidden>
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							펠로우십
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>김주연</strong> <LineBreakOnMobile fallback="/" /> <em>생물다양성, 재생에너지 공존모델</em>
							</Text>
							<Text color="b.g">
							02-6925-4253 <LineBreakOnMobile fallback="/" /> <a href="mailto:kjy01826@koreashe.org">kjy01826@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
				</ContactSection>

				<Heading as="h2" size="3xl" color="b.g" pt="14">
					1인가구 솔루션센터
				</Heading>
				<Divider color="b.dgr" mt="6" mb="6" />
				<ContactSection>
					<Flex pb="9" direction={flexBoxDirection}>
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							센터장
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>박민선</strong> <LineBreakOnMobile fallback="/" /> <em>연구소 총괄</em>
							</Text>
							<Text color="b.g">
								02-6959-9613 <LineBreakOnMobile fallback="/" /> <a href="mailto:mspark@koreashe.org">mspark@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
					<Flex pb="9" direction={flexBoxDirection}>
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							연구원
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>전상아</strong>
								<br />
								<br />
								<strong>최하연</strong>
							</Text>
							<Text color="b.g">
								02-6959-9609 <LineBreakOnMobile fallback="/" /> <a href="mailto:schun@koreashe.org">schun@koreashe.org</a>
								<br />
								<br />
								<a href="mailto:hychoi@koreashe.org">hychoi@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
				</ContactSection>

				<Heading as="h2" size="3xl" color="b.g" pt="6">
					에코 아카이브&amp;아트센터
				</Heading>
				<Divider color="b.dgr" mt="6" mb="6" />
				<ContactSection>
					<Flex pb="9" direction={flexBoxDirection}>
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							총괄감독
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>최연하</strong> <LineBreakOnMobile fallback="/" /> <em>디렉터</em>
							</Text>
							<Text color="b.g">
								02-6318-9009 <LineBreakOnMobile fallback="/" /> <a href="mailto:eac@koreashe.org">eac@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
					<Flex pb="9" direction={flexBoxDirection}>
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							코디네이터
						</Heading>
						<Flex w={isMobile ? "100%" : "60%"}>
							<Text w="50%" color="b.g">
								<strong>신동효</strong>
								<br />
								<br />
								<strong>윤승희</strong>
							</Text>
							<Text color="b.g">
								<a href="mailto:hyodong@koreashe.org">hyodong@koreashe.org</a>
								<br />
								<br />
								<a href="mailto:ysh@koreashe.org">ysh@koreashe.org</a>
							</Text>
						</Flex>
					</Flex>
					<Flex pb="9" direction={flexBoxDirection}>
						<Heading w={isMobile ? "100%" : "40%"} size="xl" color="b.g" fontWeight="normal" pb={isMobile ? 4 : 0}>
							공간풀숲
						</Heading>
						<Text w={isMobile ? "100%" : "60%"} color="b.g">
							서울시 종로구 경희궁3가길 8-4
							<br />
							<em>매주 월·화 휴관 / 관람시간: 12-6pm</em>
						</Text>
					</Flex>
				</ContactSection>
			</Section>

			<Section pt={110}>
				<Heading as="h1" size="4xl" color="b.g" pb="10" id="about01">
					핵심가치
				</Heading>
				<Flex>
					<Box>
						<Image src="/images/about/value01.png" />
						<Text textAlign="center" fontSize="{isMobile ? 12 : 24}" fontWeight={700}>공공성</Text>
					</Box>
					<Spacer />
					<Box>
						<Image src="/images/about/value02.png" />
						<Text textAlign="center" fontSize="{isMobile ? 12 : 24}" fontWeight={700}>투명성</Text>
					</Box>
					<Spacer />
					<Box>
						<Image src="/images/about/value03.png" />
						<Text textAlign="center" fontSize="{isMobile ? 12 : 24}" fontWeight={700}>전문성</Text>
					</Box>
					<Spacer />
					<Box>
						<Image src="/images/about/value04.png" />
						<Text textAlign="center" fontSize="{isMobile ? 12 : 24}" fontWeight={700}>독립성</Text>
					</Box>
				</Flex>
			</Section>

			<Section>
				<Heading as="h1" size="4xl" color="b.g" pb="10">
					인재상
				</Heading>
				<Flex direction={flexBoxDirection} alignItems="center">
					<Box maxW="sm" pb={isMobile ? 10 : 0}>
						<Flex direction={isMobile ? "row" : "column"}>
							<Image objectFit={isMobile ? "contain" : "none"} src="/images/about/pp01.png" width={isMobile ? "100px" : "auto"} />
							<Box pl={isMobile ? 6 : 0}>
								<Heading as="h2" size="2xl" pb="4" pt={8}>
									과학에 기반한 사고를 하는 인재
								</Heading>
								<Text>합리성과 비판적 사고력을 갖추고 항상 혁신하는 자세로 해당 분야 최고의 전문성을 추구하는 인재와 함께합니다.</Text>
							</Box>
						</Flex>
					</Box>
					<Spacer />
					<Box maxW="sm">
						<Flex direction={isMobile ? "row" : "column"}>
							<Image objectFit={isMobile ? "contain" : "none"} src="/images/about/pp02.png" width={isMobile ? "100px" : "auto"} />
							<Box pl={isMobile ? 6 : 0}>
								<Heading as="h2" size="2xl" pb="4" pt={8}>
									협력의 힘을 믿는 인재
								</Heading>
								<Text>혼자보다 함께 함으로써 더 큰 힘을 발휘할 수 있다는신념으로, 소통과 협동을 중시하고 주변 사람들과 조화를이루고자 하는 인재와 함께합니다.</Text>
							</Box>
						</Flex>
					</Box>
					<Spacer />
					<Box maxW="sm">
						<Flex direction={isMobile ? "row" : "column"}>
							<Image objectFit={isMobile ? "contain" : "none"} src="/images/about/pp03.png" width={isMobile ? "100px" : "auto"} />
							<Box pl={isMobile ? 6 : 0}>
								<Heading as="h2" size="2xl" pb="4" pt={8}>
									공공의 가치를 존중하는 인재
								</Heading>
								<Text>사회 구성원이라는 인식과 그에 맞는 도덕적 품성을 갖추고난제 해결을 위한 행동과 실천으로 사회에 기여하고자 하는인재와 함께합니다.</Text>
							</Box>
						</Flex>
					</Box>
				</Flex>
			</Section>

			<Section background="llg" pb={1}>
				<HistorySection>
					<Heading as="h1" size="4xl" color="b.g" pb="20">
						연혁
					</Heading>
					{!historyTermsIsLoading && historyTerms && (
						<Tab
							list={historyTerms.map((item: any) => {
								return { label: item.name, value: item.slug };
							})}
							selectedItemIndex={historySelected}
							onClickItem={onClickHistoryItem}
							size="4xl"
							wrap
						/>
					)}
					<Box pt="10" className="history-content">
						{!historyListIsLoading && Array.isArray(historyList) && historyList.length !== 0 && (
							<Slider {...historySliderSetting}>
								{historyList.map((item: any, index: number) => (
									<div key={index}>
										<Box w="600px" marginRight="6" minH={isMobile ? "200px" : "400px"}>
											<Heading size="2xl" color="b.gr" pb="5">
												{item.title}
											</Heading>
											<Text
												lineHeight="2"
												dangerouslySetInnerHTML={{
													__html: lineBreakToBr(item.content),
												}}
											/>
										</Box>
									</div>
								))}
							</Slider>
						)}
					</Box>
				</HistorySection>
			</Section>

			<Section background="llg">
				<Heading as="h1" size="5xl" color="b.bk" pb="5" id="about04">
					활동·재정보고
				</Heading>
				<Heading as="h2" size="xl" pb="80px">
					숲과나눔은 공익법인 회계기준에 따라 결산내역과 감사결과를 투명하게 공시합니다.
				</Heading>
				{!financeTermsIsLoading && orderedFinanceTerms && (
					<Tab
						list={orderedFinanceTerms.map((item: any) => {
							return { label: item.name, value: item.slug };
						})}
						selectedItemIndex={financeSelected}
						onClickItem={onClickFinanceItem}
						size={isMobile ? "lg" : "2xl"}
					/>
				)}
				<Box className="history-content">
					{!financeIsLoading && Array.isArray(financeList) && financeList.length !== 0 && (
						<Slider {...historySliderSetting} slidesToShow={isMobile ? 1 : 4}>
							{financeList.map((item: any, index: number) => (
								<div key={index}>
									<Link href={`/board/?mode=view&board_id=finance&post_id=${item.id}&reqmode=wp`}>
										<Box w="300px" marginRight={isMobile ? "0" : "6"} minH="400px">
											<Image src={item.featured_full} w={isMobile ? "100%" : "282px"} />
											<Heading size="xl" color="b.bk" pb="5" pt="5">
												<Flex alignItems="center">
													{item.title} <Image src="/images/icons/download_g.svg" pl="4" />
												</Flex>
											</Heading>
										</Box>
									</Link>
								</div>
							))}
						</Slider>
					)}
				</Box>
				<Box textAlign="center" pt="60px">
					<Link href="https://teht.hometax.go.kr/websquare/websquare.wq?w2xPath=/ui/sf/a/c/UTESFACJ01.xml&tmIdx=0&tm2lIdx=&tm3lIdx=" isExternal>
						<Button size="lg" colorScheme="dgr" variant="outline">
							국세청 공시 및 공개 시스템 바로가기
						</Button>
					</Link>
				</Box>
			</Section>

			<Section pt={100}>
				<Heading as="h1" size="5xl" pb="8" id="about06">
					공간 활용
				</Heading>
				<Heading as="h2" size="2xl" color="b.g" pb="10" lineHeight="1.5">
					재단 공간의 적극적 활용으로
					<br />더 나은 사회를 만들기 위한
					<LineBreakOnMobile /> 만남의 장을 열어갑니다
				</Heading>
				<Image src="/images/about/space.png" />
				<Text pt="8" pb="20">
					숲과나눔은 건강하고 생산적인 지식생태계 구축을 위해 환경·안전·보건 분야에 필요한 각종 교육과 회의, 세미나, 행사 등에 공간을 지원하고 있습니다. 지원을 원하시는 유관기관 및 단체는 아래 링크를 통해 신청서를 작성해주시면 담당자 검토 후 연락을
					드립니다.
				</Text>

				<Grid templateColumns="repeat(2, 1fr)" gap="6">
					<GridItem>
						<Heading size="2xl" color="b.g" pb="4">
							강당
						</Heading>
						<Text color="b.g">
							- 스크린, 빔프로젝터, 무선마이크, 유선마이크, 공용컴퓨터, 포인터 등 장비 이용 가능
							<br />- 현수막 사이즈 : 가로형 기본 400cm X 90cm(자석으로 부착하는 형태)
						</Text>
					</GridItem>
					<GridItem>
						<Heading size="2xl" color="b.g" pb="4">
							회의실
						</Heading>
						<Text color="b.g">스크린, 빔프로젝터, 공용노트북, TV, 화상회의용 웹캠 등 장비 이용 가능</Text>
					</GridItem>
					<GridItem>
						<Divider color="b.lg" mt="0" mb="6" />
						<Heading size="2xl" color="b.g" pb="4">
							사용목적
						</Heading>
						<Text color="b.g">
							- 교육 연구를 위한 국내 외 각종회의
							<br />
							- 각종 학회나 세미나
							<br />
							- 재단에서 주관 또는 후원하는 행사
							<br />
							- 공공성이 인정되는 기관 및 단체가 주최 또는 주관하는 행사
							<br />- 기타 이사장이 인정하는 행사
						</Text>
					</GridItem>
					<GridItem>
						<Divider color="b.lg" mt="0" mb="6" />
						<Heading size="2xl" color="b.g" pb="4">
							사용시간
						</Heading>
						<Text color="b.g">
							- 평일 9:00AM~6:00PM
							<br />- 토·일요일, 공휴일 휴관
						</Text>
					</GridItem>
				</Grid>

				<Box bg="b.llg" padding="8" mt="8">
					<Heading size="2xl" color="b.g" pb="6">
						신청 시 유의사항
					</Heading>
					<Text color="b.g">
						- 예약일정 변경 또는 예약취소는 반드시 신청서 접수 후 4일 이내에 미리 고지하여야 합니다.
						<br />
						- 예약된 시간까지 퇴실을 완료하여야 합니다.
						<br />
						- 무선마이크, 인터넷 전용회선 등 정밀기기는 사용 중 오류가 발생할 수 있습니다.
						<br />
						- 장비 파손 및 고장 발생 시 수리 또는 동일 모델로 교체해야 합니다.
						<br />- 공간 활용 시 발생한 쓰레기 및 재활용품은 직접 처리해야 합니다. (재단 처리 시 비용 발생)
					</Text>
				</Box>

				<Box pt="12">
					<Center>
						<a href="/form?form_id=97747">
							<Button size="xl" colorScheme="og">
								신청하기
							</Button>
						</a>
					</Center>
				</Box>
			</Section>

			<Section pt={1} pb={200}>
				<Heading as="h1" size="5xl" pb="8" id="about07">
					오시는 길
				</Heading>
				<Heading as="h2" size="2xl" color="b.g" pb="10" lineHeight="1.5">
					지하철 3호선, 신분당선 양재역 인근 위치 5번 출구에서 도보 10M, 3분 소요
				</Heading>

				<Image src="/images/about/map.png" />

				<Flex justify="space-between" pt="12" direction={flexBoxDirection}>
					<Box>
						<Heading size="2xl" pb="4">
							재단법인 숲과나눔
						</Heading>
						<Text color="b.g">Korea Safety Health Environment Foundation</Text>
					</Box>
					<Text w={isMobile ? "100%" : "50%"} fontSize="xl" color="b.g">
						06737 서울 서초구 남부순환로 2606, 금정빌딩 6층
						<br />
						TEL : 02-6318-9000
						<br />
						FAX : 02-6318-9100
						<br />
						E-mail : koreashe@koreashe.org
					</Text>
				</Flex>

				{/* <Divider color="b.g" mt="10" mb="10" /> */}

				{/* <Flex justify="space-between" direction={flexBoxDirection}>
					<Heading size="2xl" color="b.gr">
						지하철
					</Heading>
					<Text color="b.g" w={isMobile ? "100%" : "60%"} fontSize="xl" lineHeight="2">
						3호선 양재역 하차, 5번출구→ 약 70미터 직진 → 금정빌딩 6층
					</Text>
				</Flex>
				<Divider color="b.lg" mt="8" mb="8" />
				<Flex justify="space-between" direction={flexBoxDirection}>
					<Heading size="2xl" color="b.gr">
						버스
					</Heading>
					<Text color="b.g" w={isMobile ? "100%" : "60%"} fontSize="xl" lineHeight="2">
						양재역.양재1동민원분소(정류장 22-270)에서 양재역 방향 약 150미터 도보 이동
						<br />
						양재역4번출구 (정류장 23-918)에서 양재전화국 사거리 방향 육교 이용 (횡단보도 1회 횡단) 양재역 방향으로 약 150미터 도보 이동
						<br />
						양재역.서초문화예술회관 (정류장 22-003)에서 3호선 양재역 5번 출구 방향 도보로 170미터 이동 후 우회전 다시 양재전화국 사거리 방향 70미터 직진
					</Text>
				</Flex>
				<Divider color="b.lg" mt="8" mb="8" />
				<Flex justify="space-between" direction={flexBoxDirection}>
					<Heading size="2xl" color="b.gr">
						승용차
					</Heading>
					<Text color="b.g" w={isMobile ? "100%" : "60%"} fontSize="xl" lineHeight="2">
						3호선 양재역 5번출구 10미터 앞→ 남서울농협 양재역 지점 골목으로 진입→
						<br />
						농협 옆 건물 주차장 (금정빌딩)
					</Text>
				</Flex> */}

				{/* <Divider color="b.g" mt="10" mb="10" /> */}
			</Section>

			{/* <Section>
				<Heading as="h1" size="4xl" color="b.g" pb="8">
					숲과나눔 BI(Brand Identity)
				</Heading>
				<Text color="b.g">
					숲과나눔의 심벌은 무한대의 형상 속에 숲을 상징하는 나무와 사람, 나눔을 상징하는 지구의 형태가 서로 맞닿아 있는 모습입니다.
					<br />
					숲, 환경을 상징하는 초록색과 사람, 문화를 상징하는 회색이 서로의 색감을 조금씩 덜어내고 나누어, 어울리고 함께하는 자연스러운 농담으로 표현돼 있습니다.
					<br />
					디자인과 색을 최대한 절제하고 오직 ‘재단법인 숲과나눔’이라는 명칭과 의미 속에서 그 담음새를 완성했습니다.
					<br />
					나무와도 같은 사람·인재·마음, 숲을 닮은 지구·사회·환경, 환경·안전·보건 분야 인재에서 인재로 이어지는 지속가능하고 아름다운 세상을 담았습니다.
				</Text>
				<Box pt="28">
					<Center>
						<Image src="/images/about/bi.png" maxW={isMobile ? "330px" : "554px"} />
					</Center>
				</Box>
			</Section>

			<Center>
				<Divider orientation="horizontal" color="b.lg" maxW="1200" />
			</Center>

			<Section>
				<Heading as="h1" size="4xl" color="b.g" pb="8">
					Brand Color
				</Heading>
				<Text color="b.g" pb="20">
					숲과나눔의 컬러웨이는 활용에 따라 4도 원색 인쇄와 메인 지정 컬러 팬톤 별색 인쇄를 활용하여 사용할 수 있습니다.
					<br />
					상황과 적용 매체에 따라 4도 원색 컬러, 보조 컬러와 먹 1도 조합을 서브 컬러로 활용합니다.
				</Text>
				<Center>
					<Image src="/images/about/color.png" />
				</Center>
			</Section> */}

			{/* <Section>
				<Heading as="h1" size="5xl" color="b.bk" pb="6">
					일환경건강센터
				</Heading>
				<Heading as="h2" size="2xl" color="b.g" lineHeight="1.5" pb="10">
					일터의 환경·안전·보건 문제를 해결하고 지역사회를 보다 안전하고 건강하게 만들기 위해
					<br />
					숲과나눔이 설립한 민간 최초 공익 산업보건센터입니다.
				</Heading>
				<Image src="/images/about/cweh.png" />
				<Text pt="8">
					(재)숲과나눔 인활경건강센터는 SK하이닉스 협력사와 지역사회 영세업체 노동자들에게 산업안전보건 서비스를 제공함으로써 안전사고를 최소화하고 직업병 예방에 도움을 주는 공익 기능을 수행하고 있습니다. 사내에 보건관리자가 없는 영세업체
					노동자들에게도 전문적인 산업보건 지식과 건강상담을 무료로 제공하고 있습니다.
				</Text>

				<Divider color="b.dgr" mt="14" mb="6" />

				<Grid templateColumns={isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem rowSpan={2}>
						<Heading size="2xl" color="b.g">
							사업안내
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between" direction={flexBoxDirection}>
							<Text w={isMobile ? "100%" : "50%"} fontSize="xl" color="b.lg" fontWeight="bold" mb={isMobile ? 8 : 0}>
								- 일터 주치의
								<br />
								<br />
								- 지역 직업건강역량강화
								<br />
								<br />- 취약노동자 안전보건
							</Text>
							<Text w={isMobile ? "100%" : "50%"} fontSize="xl" color="b.lg" fontWeight="bold">
								- 안전보건문화확산
								<br />
								<br />
								- 지역사회 협력사업
								<br />
								<br />- SK하이닉스 협력사 지원사업
							</Text>
						</Flex>
					</GridItem>
				</Grid>

				<Divider color="b.dgr" mt="14" mb="6" />

				<Grid templateColumns={isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem rowSpan={2}>
						<Heading size="2xl" color="b.g">
							직업건강 프로그램
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between" direction={flexBoxDirection}>
							<Text w={isMobile ? "100%" : "50%"} fontSize="xl" color="b.lg" fontWeight="bold" mb={isMobile ? 8 : 0}>
								- 직업병 건강상담
								<br />
								<br />
								- 직무스트레스 예방상담
								<br />
								<br />- 뇌심혈관질환 예방상담
							</Text>
							<Text w={isMobile ? "100%" : "50%"} fontSize="xl" color="b.lg" fontWeight="bold">
								- 작업환경상담
								<br />
								<br />
								- 근골격계질환 예방상담
								<br />
								<br />- 안전보건교육
							</Text>
						</Flex>
					</GridItem>
				</Grid>

				<Divider color="b.wh" mt="14" mb="6" />

				<Grid templateColumns={isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)"} gap={6}>
					<GridItem rowSpan={2}>
						<Heading size="2xl" color="b.g">
							오시는 길
						</Heading>
					</GridItem>
					<GridItem colSpan={2}>
						<Flex justify="space-between">
							<Text fontSize="xl" color="b.bk">
								월-금 9:00 ~ 19:00 / 토, 일, 공휴일 휴무 <br /> 온라인 사전 예약 후 방문 권장
								<br />
								<br />
								충청북도 청주시 흥덕구 직지대로 530
								<br />
								청주테크노S타워 동관 212호
								<br />
								<br />
								E-mail : center@cweh-koreashe.org
								<br />
								phone : 043-904-7411~5
							</Text>
						</Flex>
					</GridItem>
				</Grid>
			</Section> */}

			<Section background="llg" display="none" >
				<Heading as="h1" size="5xl" pb="8">
					풀씨행동연구소
				</Heading>
				<Heading as="h2" size="2xl" color="b.g" pb="20">
					환경사회문제 해결을 위해 조직하고 연구하고
					<LineBreakOnMobile /> 행동하는 연구소입니다.
				</Heading>
				{/* <Heading as="h3" size="4xl" color="b.dgr" pb="8">
					운영기조
				</Heading>
				<Text color="b.g" fontSize="xl">
					1. 연구/조직/행정 등 기능중심 역할분담 대신 과제별 팀 구성으로 통합성 제고
					<br />
					2. 근무 및 계약형태를 다양화하여 인재의 참여 확대
					<br />
					3. 장기과제 중심의 역량축적과 단기과제 대응을 통한 영향력 확대의 균형 모색
				</Text> */}

				{/* <Divider color="b.lg" mt="10" mb="10" /> */}

				<Heading as="h3" size="4xl" color="b.dgr" pb="12">
					주요 사업
				</Heading>

				<Flex justify="space-between" pb="12" direction={flexBoxDirection}>
					<Box paddingRight="4">
						<Heading size="2xl" pb="4">
							생물다양성 보전
						</Heading>
						{/* <Heading size="lg" color="b.g" fontWeight="normal" pb="4">
							‘1인 가구’의 대한 사회적 인식을 개선하고, 관련 정책의 변화를 견인하며, 건강한 사회적 관계 맺기를 촉발한다.
						</Heading> */}
						{/* <Divider color="b.gr" mt="2" mb="5" /> */}
						<Text color="b.g" fontSize="lg">
						- 생물다양성 모니터링 및 인재 양성│ECOSEE<br />
						- 더많은자연(Nature Positive) 캠페인<br />
						- 담수생태계 복원 캠페인
						</Text>
					</Box>
					<Image src="/images/about/cen01.png" mt={isMobile ? "10" : "0"} />
				</Flex>

				<Flex justify="space-between" pb="12" direction={flexBoxDirection}>
					<Box paddingRight="4">
						<Heading size="2xl" pb="4">
						그린아고라
						</Heading>
						{/* <Heading size="lg" color="b.g" fontWeight="normal" pb="4">
							과학적 합리성에 근거한 사회적 토론을 활성화하고 실천 대안을 모색한다.
						</Heading> */}
						{/* <Divider color="b.gr" mt="2" mb="5" /> */}
						<Text color="b.g" fontSize="lg">
						- &lt;삶을 위한 도시&gt; 포럼<br/>
					- 자전거시민포럼<br/>
					- 포럼 생명자유공동체<br/>
					- 한반도청년환경포럼
						</Text>
					</Box>
					<Image src="/images/about/cen02.png" mt={isMobile ? "10" : "0"} />
				</Flex>

				<Flex justify="space-between" direction={flexBoxDirection}>
					<Box paddingRight="4">
						<Heading size="2xl" pb="4">
						전문 뉴스레터 ‘SHE’s View’ 발간
						</Heading>
						{/* <Heading size="lg" color="b.g" fontWeight="normal" pb="4">
							기존의 성과지표로 평가하기 어려운 사회적 가치 행동에 대한 측정지표를 개발하고 보급한다.
						</Heading>
						<Divider color="b.gr" mt="2" mb="5" />
						<Text color="b.g">
							- <strong>연구</strong> : 사회적가치연구원 공동 프로젝트
							<br />- <strong>조직</strong> : 중간지원조직과 지표활용 시범사업, 자문위원회, 에코솔루션 연계
						</Text> */}
					</Box>
					<Image src="/images/about/cen03.png" mt={isMobile ? "10" : "0"} />
				</Flex>

				<Divider color="b.lg" mt="10" mb="10" />

				<Heading as="h3" size="4xl" color="b.dgr" pb="8">
				오시는길
				</Heading>
				<Text color="b.g" fontSize="xl">
				월-금 9:00 ~ 17:00 / 토, 일, 공휴일 휴무<br/>
				(06737) 서울 서초구 남부순환로 350길 19-26, 도담빌딩 3층 풀씨행동연구소<br/><br/>

				E-mail : institute@koreashe.org<br/>
				phone : 02-6925-4890
				</Text>
			</Section>

		</>
	);
}

About.defaultProps = {};

export default About;
